// extracted by mini-css-extract-plugin
export default {"SchoolRegistrationForm":"School_SchoolRegistrationForm__6tM9v","SchoolList":"School_SchoolList__mvbjJ","Title":"School_Title__U5j44"};